import React from "react";
import {
  translate
} from "admin-on-rest";
import SimpleForm from "../../../components/CRM/Form/SimpleEditGiftCardForm";
import EditGiftCard from "../../../components/CRM/EditGiftCard";

import restClient from "../../../restClient";
import {giftCardForm} from "./style";
import {validateCustomerData} from "./validations";

class GiftCardEditForm extends React.Component {
  state = {
    
    kioskPromos: null,
    page: 1,
    perPage: 10,
    sort: {field: "name", order: "ASC"},
    partnerPhone: null,
    disabledInputFields: false,
    date: null,
    showEmptyFields: false
  };

  componentDidMount() {
    const {page, perPage, sort} = this.state;

    const kiosk = JSON.parse(localStorage.getItem("kiosk"));
    const kiosk_id = kiosk ? kiosk.id : '';

    const reference = `kiosks/${kiosk_id}/giftcard_promotions`;
    const pagination = {page: page, perPage: perPage};
    
    this.getKioskPromos(pagination, sort, reference);
    
  }  

  getKioskPromos(pagination, sort, reference, filter = ''){
    restClient("GET_LIST", reference, {
      pagination: {...pagination},
      sort: sort,
      filter: filter
    }).then(({data, total}) => {
      const promoChoices = (data && data.length > 0) ? data.map(promo => {
        let promoObject = {
          id: promo.id,
          name: promo.name
        };
        return promoObject;
      }) : [];
      
      this.setState({
        kioskPromos: promoChoices
      })
    });
  }
  
  render() {
    const props = {...this.props};
    const {
      record,
      disabledInputFields,
      kioskPromos,
      showEmptyFields
    } = this.state;

    const PostTitle = () => {
      return <span style={giftCardForm.titleDivider}>{this.props.translate("resources.giftCards.editGiftCard")}</span>;
    };
    
    return (
      <EditGiftCard 
        {...props}
      >        
        <SimpleForm 
          title={<PostTitle />}
          redirect="list" 
          validate={validateCustomerData} 
          style={giftCardForm.form}
          giftCardForm={giftCardForm}
          disabledInputFields={disabledInputFields}
          location={this.props.location}
          kioskPromos={kioskPromos}
          existingCustomer={record}
          showEmptyFields={showEmptyFields}
        >        
        </SimpleForm>        
      </EditGiftCard>
    );
  }
}

export default translate(GiftCardEditForm);



// WEBPACK FOOTER //
// ./src/containers/CRM/GiftCards/GiftCardEditForm.js